import { gql } from '@apollo/client';

export default gql`
  mutation addPayment($bookingReference: String!, $payments: [PaymentInput], $reason: String) {
    addPayment(bookingReference: $bookingReference, payments: $payments, reason: $reason) {
      reference

      fulfillmentMethod {
        name
        description
      }

      payments {
        id
        refId
        currency
        currencyRate
        reference
        externalReference
        refundAvailable
        provider
        method
        amount
        availableRefundAmount
        transactionTimestamp
        refundProcessTimestamp
        paymentStatus
        createdRevision
      }
    }
  }
`;
